import request from '@/utils/request'

export function selectPieceworkSet(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/pieceworkSet/selectPieceworkSet?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addPieceworkSet(data) {
    return request({
        url: `api/serviceCenter/pieceworkSet/addPieceworkSet`,
        method: 'post',
        data,
    })
}

export function upPieceworkSet(data) {
    return request({
        url: `api/serviceCenter/pieceworkSet/upPieceworkSet`,
        method: 'post',
        data,
    })
}

export function bathDeletePieceworkSet(data) {
    return request({
        url: `api/serviceCenter/pieceworkSet/bathDeletePieceworkSet`,
        method: 'post',
        data,
    })
}

export function getAllCategory(data) {
    return request({
        url: `api/serviceCenter/pieceworkSet/getAllCategory?access=${data}`,
        method: 'get',
    })
}





